<template>
  <div class="pengumuman-container">
    <Forbidden
      v-if="
      getUserRole[getUserRole.length - 1].role_id != userRole.STUDENT && 
      (
        getStudentTermStatus != termStatus.CONTINUE || 
        getPaymentId != 0
      )"
      routerPath="incorrectRole"
    />
    <Forbidden v-else-if="!getPaymentPeriodOpened" routerPath="notInPeriod" />
    <section v-else class="vector-background col center">
      <b-form id="payment-option-form">
        <h2 class="header-title">Form Pemilihan Paket Pembayaran</h2>
        <b-row align-v="start">
          <b-col sm="12" md="6">
            <b-form-group
              id="infaqOptionNumber-group"
              label="Pilihan Kontribusi Infaq"
              label-for="infaqOptionNumber"
            >
              <b-form-select
                id="infaqOptionNumber"
                v-model="form.infaqOption"
                :options="form.infaqOptionNumberOption"
                aria-describedby="infaqOptionNumber-live-feedback"
              >
                <template v-slot:first>
                  <b-form-select-option :value="null" disabled>Pilih Opsi</b-form-select-option>
                </template>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="6" v-if="form.infaqOption === 2 || form.infaqOption === 3">
            <b-form-group
              id="referralName1-group"
              v-if="form.infaqOption === 2 || form.infaqOption === 3"
              label="Sahabat kontribusi 1"
              label-for="referralName1"
            >
              <b-form-input
                id="referralName1"
                size="sm"
                placeholder="Masukkan username teman kamu di sini"
                v-model="form.referralName1"
                aria-describedby="referralName1-live-feedback"
              ></b-form-input>
              <b-form-invalid-feedback
                id="referralName1-live-feedback"
                class="error_referralName1"
              >Masukkan sahabat kontribusi 1 dengan benar</b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              id="referralName2-group"
              v-if="form.infaqOption === 3"
              label="Sahabat kontribusi 2"
              label-for="referralName2"
            >
              <b-form-input
                id="referralName2"
                size="sm"
                placeholder="Masukkan username teman kamu di sini"
                v-model="form.referralName2"
                aria-describedby="referralName2-live-feedback"
              ></b-form-input>
              <b-form-invalid-feedback
                id="referralName2-live-feedback"
                class="error_referralName2"
              >Masukkan sahabat kontribusi 2 dengan benar</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
      <b-button
        v-if="form.infaqOption !=  0"
        id="submit"
        type="submit"
        size="sm"
        for="payment-option-form"
        ref="btn-submit"
        variant="none"
        class="primary mt-4"
        @click="$bvModal.show('confirm-modal')"
      >Kirim</b-button>

      <b-modal id="confirm-modal" hide-footer>
        <template v-slot:modal-title>Konfirmasi</template>
        <div class="d-block text-center">
          <h3>Apakah kakak yakin dengan pilihan kakak?</h3>
        </div>
        <b-row class="ml-3 mt-3">
          <b-button
            class="col-5"
            variant="none"
            size="sm"
            @click="$bvModal.hide('confirm-modal')"
          >Belum Yakin</b-button>
          <b-button class="col-5 ml-3 primary" size="sm" @click="onSubmit">Yakin</b-button>
        </b-row>
      </b-modal>
    </section>
  </div>
</template>

<script>
import Forbidden from "@/views/Forbidden";
import { mapGetters } from "vuex";
import User from "@/services/User";
import { UserRole, TermStatus } from "@/services/StatusCode";

export default {
  name: "ReferralNamesForm",
  data() {
    return {
      form: {
        infaqOption: 0,
        infaqOptionNumberOption: [
          { value: 1, text: "Paket Sendiri (Rp.150.000)" },
          { value: 2, text: "Paket Berdua (Rp.280.000)" },
          { value: 3, text: "Paket Bertiga (Rp.400.000)" }
        ],
        referralName1: "",
        referralName2: ""
      },
      userRole: UserRole,
      termStatus: TermStatus
    };
  },
  components: {
    Forbidden
  },
  methods: {
    onSubmit() {
      this.postForm();
    },
    postForm() {
      User.uploadReferralPayment(
        process.env.VUE_APP_URL,
        this.getAccessToken,
        this.getTermName,
        this.form
      ).then(() => {
        User.getDataPembayaran(
          process.env.VUE_APP_URL,
          this.getAccessToken,
          this.getTermName
        );
        location.href = location.origin + "/";
      });
    }
  },
  async created() {
    if (this.getStudentTermStatus == TermStatus.CONTINUE) {
      await User.getDataPembayaran(
        process.env.VUE_APP_URL,
        this.getAccessToken,
        this.getTermName
      );
    }
  },
  computed: {
    ...mapGetters({
      getAccessToken: "getAccessToken",
      getUserId: "getUserId",
      getUserRole: "getUserRole",
      getTermName: "getTermName",
      getFullname: "getFullname",
      getStudentTermStatus: "getStudentTermStatus",
      getPaymentPeriodOpened: "getPaymentPeriodOpened",
      getPaymentId: "getPaymentId"
    })
  }
};
</script>


<style lang="scss" scoped>
@import "@/styles/form.scss";

@media only screen and (min-width: 768px) {
  h1.header-title {
    font-size: $h1 !important;
  }

  h2.header-title {
    font-size: $h2 !important;
  }

  h3.header-title {
    font-size: $h3 !important;
  }

  .hero-message {
    margin-bottom: 5%;
    max-width: 50%;
  }
  .message {
    max-width: 100% !important;
    font-size: 16px !important;
  }
}

.pengumuman-container {
  min-height: inherit;
}

.rejected {
  color: red;
}

.hero-message {
  max-width: 75%;
  margin-bottom: $gap-m-2;
}

.message {
  margin-top: $gap-sm-1;
  text-align: center;
  max-width: 80%;
  font-size: 12px;
}

.message-container {
  min-width: 20%;
  max-height: 40%;
  margin-bottom: $gap-m-2;
}

.header-title {
  margin-bottom: $gap-m-1;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
}

.nominal-container {
  text-align: center;
  .nominal {
    font-size: 24px;
  }
}
.pembayaran-container {
  .salin-jumlah {
    color: $primary;
  }
}

.success-payment-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.rekening-container {
  display: flex;
  align-items: center;
  margin: $gap-sm-2 0;

  .rekening {
    padding: $gap-sm-1 $gap-sm-2;
    background: $white;
    margin-right: $gap-sm-2;
  }
}

#submit {
  display: flex;
  align-items: center;

  .material-icons {
    color: white;
    margin-left: $gap-sm-1;
  }
}

.upload-container {
  margin-top: $gap-sm-2;
}

.red {
  color: #eb4d55;
}

.black {
  color: #000000;
}

.svg-4 {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: -1;
  max-width: 40%;
  max-height: 20%;
}

.svg-5 {
  position: absolute;
  z-index: -2;
  bottom: 0;
  left: 0;
  max-width: 40%;
  max-height: 25%;
}

.svg-6 {
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: -1;
  max-width: 40%;
  max-height: 50%;
}

.svg-7 {
  position: absolute;
  z-index: -2;
  bottom: 0;
  right: 0;
  max-width: 30%;
  max-height: 50%;
}
</style>

